import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.TRANSACTION_TIMER_ACTIVE_VOLUME_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.MONTH }],
    groupBy: ChartQueryParam.NAME,
    groupByMode: ChartGroupByMode.VALUE
};
